import React from 'react'
import {Link, useNavigate} from 'react-router-dom'

export interface Route {
  name: string
  url: string
}
interface Breadcrumb {
  routes: Route[]
  containerClass?: string
}
export function Breadcrumbs({routes, containerClass}: Breadcrumb) {
  const navigate = useNavigate()

  return (
    <div className={`row ${containerClass ? containerClass : 'mx-10'}`}>
      <div className='col-sm-10 col px-0 align-items-center d-flex mt-10'>
        {routes && (
          <ul className='breadcrumb breadcrumb-transparent breadcrumb-lessthan font-weight-bold p-0 mb-0 font-size-sm'>
            {routes?.map((list: any, index: number) => {
              const isLast = index === routes.length - 1
              if (isLast) {
                return (
                  <li className='breadcrumb-item text-muted' key={index}>
                    {list.name}
                  </li>
                )
              }
              return (
                <li className='breadcrumb-item text-active' key={index}>
                  <Link to={list.url}>{list.name}</Link>
                </li>
              )
            })}
          </ul>
        )}
      </div>
      <div className='col-sm-2 col px-0 justify-content-end d-flex flex-grow-0 mt-sm-10 mt-10 ms-sm-0 ms-3'>
        <Link
          to=''
          onClick={() => navigate(-1)}
          className='btn btn-primary position-relative py-2 px-5 fw-bolder fs-7 d-flex align-items-center'
          style={{height: '31px', minWidth: '72px'}}
        >
          <i className='fa fa-angle-left'></i> Back
        </Link>
      </div>
    </div>
  )
}
